import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Database } from '../types/supabase';

type Tables = Database['public']['Tables'];
type Tool = Tables['tools']['Row'];

export const useTools = () => {
  return useQuery<Tool[]>({
    queryKey: ['tools'],
    queryFn: async () => {
      console.log('Fetching tools from Supabase...');
      
      try {
        const { data, error } = await supabase
          .from('tools')
          .select('*');

        if (error) {
          console.error('Supabase query error:', error);
          throw new Error(`Failed to fetch tools: ${error.message}`);
        }

        if (!data) {
          console.warn('No data returned from Supabase');
          return [];
        }

        console.log('Successfully fetched tools:', data);
        return data;
      } catch (error) {
        console.error('Unexpected error:', error);
        throw error;
      }
    }
  });
};

export const useToolById = (id: number) => {
  return useQuery<Tool>({
    queryKey: ['tool', id],
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .from('tools')
          .select('*')
          .eq('id', id)
          .single();

        if (error) {
          console.error('Supabase query error:', error);
          throw new Error(`Failed to fetch tool ${id}: ${error.message}`);
        }

        if (!data) {
          throw new Error(`Tool ${id} not found`);
        }

        return data;
      } catch (error) {
        console.error('Unexpected error:', error);
        throw error;
      }
    }
  });
}; 